import React from 'react';

import { Preset, Text } from '@lux/text/tw';
import { Title, TitlePreset } from '@lux/title/tw';
import { FunctionColor } from '@lux/core';
import { GlobalRetailEvent } from '@shared/types/mylounge';

interface GRETabHeaderProps {
    isCyberWeek?: boolean;
    globalRetailEvent: GlobalRetailEvent;
}

export const GRETabHeader: React.FC<GRETabHeaderProps> = ({ isCyberWeek, globalRetailEvent }) => {
    return (
        <div className="flex h-full flex-col items-center justify-center">
            <Title
                preset={TitlePreset.S}
                color={FunctionColor.function100}
                className={`m-0 w-full text-center${isCyberWeek ? ' !text-complementary-neon-fresh' : ''}`}
            >
                {globalRetailEvent.title}
            </Title>
            <Text
                preset={Preset.S}
                color={FunctionColor.function100}
                className={`m-0 block w-full text-center${isCyberWeek ? ' !text-complementary-neon-fresh' : ''}`}
            >
                {globalRetailEvent.content}
            </Text>
        </div>
    );
};
